
import Router from 'vue-router'
import Vue from 'vue'

Vue.use(Router)

let router = new Router()

let routeConfig = [
  {
    path: '/',
    redirect: '/Home'
  },
  {
    path: '/Home',
    meta: {
      title: '商周科技',
      auth: false
    },
    component: () => import('../views/Home')
  },
  {
    path: '/Article',
    meta: {
      title: '高考日历',
      auth: false
    },
    component: () => import('../views/Article')
  },
  {
    path: '/Invite',
    meta: {
      title: '好友赠送您30天高级会员',
      auth: false
    },
    component: () => import('../views/Invite')
  },
  {
    path: '/studyRoomHome',
    meta: {
      title: '清单自习室App',
      auth: false
    },
    component: () => import('../views/studyRoomHome')
  },
  {
    path: '/studyRoomPrivacy',
    meta: {
      title: '隐私协议',
      auth: false
    },
    component: () => import('../views/studyRoomPrivacy')
  },
  {
    path: '/studyRoomPrivacyiOS',
    meta: {
      title: '隐私协议_iOS',
      auth: false
    },
    component: () => import('../views/studyRoomPrivacyiOS')
  },
  {
    path: '/studyRoomPrivacyHM',
    meta: {
      title: '隐私协议_鸿蒙',
      auth: false
    },
    component: () => import('../views/studyRoomPrivacyHM')
  },
  {
    path: '/studyRoomUserAndroid',
    meta: {
      title: '用户协议_Android',
      auth: false
    },
    component: () => import('../views/studyRoomUserAndroid')
  },
  {
    path: '/studyRoomUseriOS',
    meta: {
      title: '用户协议_iOS',
      auth: false
    },
    component: () => import('../views/studyRoomUseriOS')
  },
  {
    path: '/studyRoomUserHM',
    meta: {
      title: '用户协议_鸿蒙',
      auth: false
    },
    component: () => import('../views/studyRoomUserHM')
  },
  {
    path: '/studyRoomUserInfo',
    meta: {
      title: '个人信息收集清单',
      auth: false
    },
    component: () => import('../views/studyRoomUserInfo.vue')
  },
  {
    path: '/studyRoomSdkInfo',
    meta: {
      title: 'SDK信息',
      auth: false
    },
    component: () => import('../views/studyRoomSdkInfo.vue')
  },
  {
    path: '/studyRoomXhs',
    meta: {
      title: '推荐有礼',
      auth: false
    },
    component: () => import('../views/studyRoomXhs')
  },
  {
    path: '/studyRoomSupport',
    meta: {
      title: '技术支持',
      auth: false
    },
    component: () => import('../views/studyRoomSupport')
  },
  {
    path: '/gaokaoCalPrivacyHM',
    meta: {
      title: '隐私协议',
      auth: false
    },
    component: () => import('../views/gaokaoCalPrivacyHM.vue')
  },
  {
    path: '/gaokaoCalUserHM',
    meta: {
      title: '用户协议',
      auth: false
    },
    component: () => import('../views/gaokaoCalUserHM.vue')
  },
  {
    path: '/gaokaoCalPrivacy',
    meta: {
      title: '隐私协议',
      auth: false
    },
    component: () => import('../views/gaokaoCalPrivacy.vue')
  },
  {
    path: '/gaokaoCalUser',
    meta: {
      title: '用户协议',
      auth: false
    },
    component: () => import('../views/gaokaoCalUser.vue')
  },
  {
    path: '/gaokaoCalSDKInfo',
    meta: {
      title: '隐私协议',
      auth: false
    },
    component: () => import('../views/gaokaoCalSdkInfo.vue')
  },
  {
    path: '/gaokaoCalUserInfo',
    meta: {
      title: '隐私协议',
      auth: false
    },
    component: () => import('../views/gaokaoCalUserInfo.vue')
  },
  {
    path: '/*',
    redirect: '/Home'
  }
]

// 添加动态路由
router.addRoutes(routeConfig)

router.beforeEach((to, from, next) => {
  console.log('Router beforeEach:', from.path, '->', to.path)
  //   if (to.meta.auth === true && !localStorage.getItem('userToken')) {
  //     next({ path: '/login' });
  //   } else {
  //     next();
  //   }
  next()
})

export { router }
